import React, {Component} from "react"
import {Container} from "reactstrap"
import ReactDOM from 'react-dom'
import { Amplify } from 'aws-amplify';
import amplifyconfig from '../../../amplifyconfiguration.json';
import { post } from 'aws-amplify/api';
import {Form, Label, FormGroup, Input, FormFeedback} from "reactstrap"
import scrollToElement from "scroll-to-element"
import styled from "styled-components"
import Button from "components/shared/Button"
import Text from "components/shared/Text"
import {
    validateRequired,
    validateEmail
} from 'utils/validations'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faAngleDown, faAngleUp} from "@fortawesome/pro-light-svg-icons"

Amplify.configure(amplifyconfig);

const FormStyled = styled(Form)`
    label {
        text-transform: uppercase;
        margin: 0;
        font-size: ${props => props.theme.font.size.sm};
    }

    .form-control {
        height: 50px;
        border-radius: 0;
        border-color: ${props => props.theme.colors.grey2};

        &::placeholder {
            color: ${props => props.theme.colors.whiteOff};
        }
    }

    select {
        appearance: none;
    }

    svg {
        position: absolute;
        right: 1rem;
        top: .8rem;
        color: ${props => props.theme.colors.secondary};
        font-size: 1.5rem;
    }

    textarea.form-control {
        min-height: 150px;
    }

    .invalid-feedback {
        color: ${props => props.theme.colors.primary};
    }

    .form-control.is-invalid:focus {
        border-color: ${props => props.theme.colors.primary};
        box-shadow: 0;
    }
`

const SubmitButton = styled(Button)`
    padding-right: 3rem;
    padding-left: 3rem;
`

const FormFeedbackStyled = styled(FormFeedback)`
    text-align: right;
`

const DropdownButton = styled.button`
    border: 0;
    padding: 0;
    display: block;
    width: 100%;
`

class ContactForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            dropdownOpen: false,
            name: '',
            telephone: '',
            email: '',
            enquiry_type: 'General',
            send_to: 'info@chevronchampionship.com',
            message: '',
            googleVerified: '',
            sendingFormRequest: false,
            validate: {
                name: '',
                telephone: '',
                email: '',
                enquiry_type: '',
                message: '',
                googleVerified: '',
                googleVerifiedErrMsg: 'Google recaptcha is required'
            },
            required: {
                name: '',
                enquiry_type: 'General',
                telephone: '',
                email: '',
            },
            success: false
        }

        // Bind this to methods
        this.handleChange = this.handleChange.bind(this)
        this.setEnquiryType = this.setEnquiryType.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        // this.onGoogleVerify = this.onGoogleVerify.bind(this)

        // Bind this to validation methods
        this.validateRequired = validateRequired.bind(this);
        this.validateEmail = validateEmail.bind(this);

        // Create form ref
        this.form = React.createRef();
        this.successMessage = React.createRef();
    }

    componentDidMount() {
        // set enquiry type for first item on load
        this.setEnquiryType(this.props.data.enquiryTypes[0].name, this.props.data.enquiryTypes[0].email)
    }

    // Method to update field values in state on change
    handleChange(e) {
        const target = e.target
        const name = target.name
        const value = target.value

        let required = this.state.required

        if (required.hasOwnProperty(name)) {
            required[name] = value
        }

        if (name === "enquiry_type") {
            // Update value in state
            const send_to = target.options[target.selectedIndex].getAttribute('data-email')
            this.setState({
                required,
                [name]: value,
                send_to
            });
        } else {
            // Update value in state
            this.setState({
                required,
                [name]: value,
            });
        }
    }

    setEnquiryType(value, send_to) {
        // set for first item on load
        this.setState({
            enquiry_type: value,
            send_to
        });
    }

    async handleSubmit(e) {
        e.preventDefault();

        //disable the button so we can't send multiple requests
        this.setState({sendingFormRequest: true});

        // Create form data ready for api wrapper call
        let formData = {};
        for (let key in this.state) {
            if (typeof this.state[key] === 'object' && this.state[key].constructor === Object) {
                for (let k in this.state[key]) {
                    formData[key + '[' + k + ']'] = this.state[key][k];
                    //formData.append(key + '[' + k + ']', this.state[key][k])
                }
            } else {
                formData[key] = this.state[key];
                //formData.append(key, this.state[key]);
            }
        }

        let {validate} = this.state
        let errors = false


        for (let key in this.state.validate) {
            if (this.state.required[key] === "" && key !== "googleVerified" && key !== "googleVerifiedErrMsg") {
                validate[key] = 'has-danger'
                errors = true
            }

            this.setState({validate});
        }

        // return if errors
        if (errors) return

        try {
            const restOperation = post({
              apiName: 'chevronContactAPI',
              path: '/contact',
              options: {
                body: formData
              }
            });
        
            const { body } = await restOperation.response;
            const response = await body.json();
        
            console.log('POST call succeeded');
            console.log(response);
      
            this.setState({
              sendingFormRequest: false,
              success: true
            });
      
            const domNode = ReactDOM.findDOMNode(this.successMessage.current)

            setTimeout(() => {
                scrollToElement(domNode, {
                    offset: -120,
                    duration: 500
                });
            }, 500);
      
          } catch (e) {
            console.log('POST call failed: ', e);
            this.setState({sendingFormRequest: false});
          }
    }

    render() {
        const {data} = this.props

        if (this.state.success) {
            return (
                <Container className="py-4">
                    <div dangerouslySetInnerHTML={{__html: data.thankyouMessage}} ref={this.successMessage}/>
                </Container>
            )
        } else {
            return (
                <Container className="py-4">
                    <FormStyled onSubmit={(e) => this.handleSubmit(e)} noValidate ref={this.form}>
                        <FormGroup>
                            <Label for="name">{data.nameHeading}<Text as="span" red>*</Text></Label>
                            <Input
                                type="text"
                                name="name"
                                id="name"
                                placeholder={data.namePlaceholder}
                                value={this.state.name}
                                valid={this.state.validate.name === 'has-success'}
                                invalid={this.state.validate.name === 'has-danger'}
                                onChange={e => {
                                    this.handleChange(e)
                                    this.validateRequired(e)
                                }}
                            />
                            <FormFeedbackStyled>
                                Your name is required
                            </FormFeedbackStyled>
                        </FormGroup>
                        <FormGroup>
                            <Label for="enquiry_type">{data.enquiryHeading}<Text as="span" red>*</Text></Label>
                            <DropdownButton className="position-relative" onClick={() => this.setState({
                                dropdownOpen: !this.state.dropdownOpen
                            })}>
                                <Input
                                    type="select"
                                    name="enquiry_type"
                                    id="enquiry_type"
                                    onChange={this.handleChange}
                                    value={this.state.enquiryTypes}
                                >
                                    {data.enquiryTypes && data.enquiryTypes.map((enquiry, i) => {
                                        return (
                                            <option
                                                key={i}
                                                value={enquiry.name}
                                                data-email={enquiry.email}
                                            >
                                                {enquiry.name}
                                            </option>
                                        )
                                    })}
                                </Input>
                                {this.state.dropdownOpen ? (
                                    <FontAwesomeIcon className="arrow" icon={faAngleUp}/>
                                ) : (
                                    <FontAwesomeIcon className="arrow" icon={faAngleDown}/>
                                )}
                            </DropdownButton>
                        </FormGroup>
                        <FormGroup>
                            <Label for="telephone">{data.telephoneHeading}<Text as="span" red>*</Text></Label>
                            <Input
                                type="text"
                                name="telephone"
                                id="telephone"
                                placeholder={data.telephonePlaceholder}
                                valid={this.state.validate.telephone === 'has-success'}
                                invalid={this.state.validate.telephone === 'has-danger'}
                                value={this.state.telephone}
                                onChange={e => {
                                    this.handleChange(e)
                                    this.validateRequired(e)
                                }}
                            />
                            <FormFeedbackStyled>
                                A valid phone number is required
                            </FormFeedbackStyled>
                        </FormGroup>
                        <FormGroup>
                            <Label for="email">{data.emailHeading}<Text as="span" red>*</Text></Label>
                            <Input
                                type="email"
                                name="email"
                                id="email"
                                placeholder={data.emailPlaceholder}
                                value={this.state.email}
                                valid={this.state.validate.email === 'has-success'}
                                invalid={this.state.validate.email === 'has-danger'}
                                onChange={e => {
                                    this.handleChange(e)
                                    this.validateRequired(e)
                                    this.validateEmail(e)
                                }}
                            />
                            <FormFeedbackStyled>
                                A valid email address is required
                            </FormFeedbackStyled>
                        </FormGroup>
                        <FormGroup>
                            <Label for="message">{data.messageHeading}</Label>
                            <Input
                                type="textarea"
                                name="message"
                                id="message"
                                value={this.state.message}
                                placeholder={data.messagePlaceholder}
                                onChange={e => this.handleChange(e)}
                            />
                        </FormGroup>
                        <Text as="span" red>*</Text> Required fields<br/>
                        <SubmitButton as="button" color="primary" className="my-3"
                                      type="submit">{data.submitText}</SubmitButton>
                    </FormStyled>
                </Container>
            )
        }
    }
}

export default ContactForm
